export const BRAND = "Zeyinx";

const configuredBackend = process.env.REACT_APP_BACKEND_URL?.trim();
const backendOrigin =
  configuredBackend ||
  (typeof window !== "undefined" ? window.location.origin : "");

export const API = `${backendOrigin.replace(/\/$/, "")}/api`;

// Direct customer support links.
export const TELEGRAM_SUPPORT_URL = "https://t.me/zeyinx";

export const SUPPORT_EMAIL = "support@zeyinx.com";

// WhatsApp support link. Use international format without + or spaces.
export const WHATSAPP_SUPPORT_URL = "https://wa.me/917909182315";
